import SectionShell from './SectionShell';
import useSectionSetup from './useSectionSetup';
import SectionHeader from './SectionHeader';
import { hexToRgba } from '../utils';
import SectionIcon from './SectionIcon';

export default function ValuesGridSection({ block = {}, primaryColor, secondaryColor, enableAnimations }) {
    const { s, ref, anim, config, content } = useSectionSetup(block, { primaryColor, secondaryColor, enableAnimations });
    const columns = config.columns || 3;
    const cols = columns === 2 ? 'md:grid-cols-2' : columns === 4 ? 'md:grid-cols-2 lg:grid-cols-4' : 'md:grid-cols-2 lg:grid-cols-3';
    const items = content.items || [];
    const variant = config.variant || 'cards';

    if (variant === 'minimal') {
        return (
            <SectionShell s={s} config={config} anim={anim} ref={ref}>
                <SectionHeader tag={content.tag} title={content.title} subtitle={content.subtitle} config={config} s={s} />
                <div className={`grid grid-cols-1 ${cols} gap-10`}>
                    {items.map((item, i) => (
                        <div key={i} className="text-center">
                            {item.icon && (
                                <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4"
                                    style={{ backgroundColor: hexToRgba(s.accent, 0.1) }}>
                                    <SectionIcon name={item.icon} size={24} style={{ color: s.accent }} />
                                </div>
                            )}
                            {item.emoji && !item.icon && <span className="text-4xl block mb-4">{item.emoji}</span>}
                            <h3 className="text-lg font-bold mb-2" style={{ color: s.text }}>{item.title}</h3>
                            {item.description && <p className="text-sm leading-relaxed" style={{ color: s.textSub }}>{item.description}</p>}
                        </div>
                    ))}
                </div>
            </SectionShell>
        );
    }

    // Default: cards variant
    return (
        <SectionShell s={s} config={config} anim={anim} ref={ref}>
            <SectionHeader tag={content.tag} title={content.title} subtitle={content.subtitle} config={config} s={s} />
            <div className={`grid grid-cols-1 ${cols} gap-6`}>
                {items.map((item, i) => (
                    <div key={i} className="rounded-2xl border p-6 transition-all duration-300 hover:-translate-y-1"
                        style={{ borderColor: hexToRgba(s.accent, 0.1), backgroundColor: hexToRgba(s.accent, 0.02) }}>
                        <div className="flex items-start gap-4">
                            {item.icon && (
                                <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0"
                                    style={{ backgroundColor: hexToRgba(s.accent, 0.1) }}>
                                    <SectionIcon name={item.icon} size={22} style={{ color: s.accent }} />
                                </div>
                            )}
                            {item.emoji && !item.icon && (
                                <span className="text-3xl shrink-0">{item.emoji}</span>
                            )}
                            <div>
                                <h3 className="text-base font-bold mb-1.5" style={{ color: s.text }}>{item.title}</h3>
                                {item.description && <p className="text-sm leading-relaxed" style={{ color: s.textSub }}>{item.description}</p>}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </SectionShell>
    );
}
